var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { observable, computed } from "mobx";
import { Player } from "../lib/qmplayer/player";
import { getLang } from "./lang";
import { CACHE_MUSIC_NAME_MP3, DATA_DIR, CACHE_IMAGES_NAME } from "./consts";
export var QUEST_SEARCH_ALL = "all";
export var QUEST_SEARCH_OWN = "own";
export function splitByBuckets(array, amountOfBuckets) {
    // Implementation is generated by github copilot, lol
    var buckets = [];
    for (var i = 0; i < amountOfBuckets; i++) {
        buckets.push([]);
    }
    array.forEach(function (item, index) {
        buckets[index % amountOfBuckets].push(item);
    });
    return buckets;
}
// tslint:disable-next-line:no-useless-cast
var DOWNLOAD_AUDIBLE_MEDIA_KEYS = ["sound", "track"];
var Store = /** @class */ (function () {
    function Store(index, app, db, player) {
        var _this = this;
        this.index = index;
        this.app = app;
        this.db = db;
        this.setPath = function () {
            var hash = location.hash.replace(/^#/, "").replace(/^\//, "");
            if (_this._hash === hash) {
                return;
            }
            _this._hash = hash;
        };
        this._hash = "";
        this.firebaseLoggedIn = undefined;
        this.firebaseSyncing = false;
        this.lastQuestListScroll = 0;
        this.serviceWorkerRegistered = false;
        this.serviceWorkerController = null;
        this.reloadingPage = false;
        this.storageIsPersisted = undefined;
        this.installingServiceWorkerState = null;
        this.waitingServiceWorkerState = null;
        this.waitingServiceWorker = null;
        this.activeServiceWorkerState = null;
        this.questsListTab = QUEST_SEARCH_ALL;
        this.questsListSearch = "";
        window.addEventListener("hashchange", this.setPath);
        this.setPath();
        this.player = player;
        this.pwaAlreadyInstalled = window.matchMedia("(display-mode: standalone)").matches;
        window.addEventListener("beforeinstallprompt", function (e) {
            e.preventDefault();
            _this.pwaInstallReadyEvent = e;
        });
        window.addEventListener("appinstalled", function (evt) {
            _this.pwaAlreadyInstalled = true;
            _this.installImagesCache().catch(function (e) { return console.warn(e); });
            _this.installMusicCache().catch(function (e) { return console.warn(e); });
        });
        this.queryCacheInfo()
            .then(function () {
            if (_this.pwaAlreadyInstalled) {
                if (_this.imagesCache === "no") {
                    _this.installImagesCache().catch(function (e) { return console.warn(e); });
                }
                if (_this.musicCache === "no") {
                    _this.installMusicCache().catch(function (e) { return console.warn(e); });
                }
            }
        })
            .catch(function (e) { return console.warn(e); });
    }
    Object.defineProperty(Store.prototype, "hash", {
        get: function () {
            return "#/" + this._hash;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "path", {
        get: function () {
            var arr = this._hash.split("/");
            return {
                tab0: arr[0],
                tab1: arr[1],
                tab2: arr[2],
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Store.prototype, "l", {
        get: function () {
            return getLang(this.player.lang);
        },
        enumerable: false,
        configurable: true
    });
    Store.prototype.loadWinProofsFromLocal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var m;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        m = new Map();
                        return [4 /*yield*/, Promise.all(this.index.quests.map(function (quest) { return __awaiter(_this, void 0, void 0, function () {
                                var passed;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.db.isGamePassedLocal(quest.gameName)];
                                        case 1:
                                            passed = _a.sent();
                                            m.set(quest.gameName, passed);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        this.wonProofs = m;
                        return [2 /*return*/];
                }
            });
        });
    };
    Store.prototype.syncWithFirebase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var player;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.firebaseSyncing) {
                            // TODO: retry sync when first finished
                            return [2 /*return*/];
                        }
                        this.firebaseSyncing = true;
                        return [4 /*yield*/, this.db.syncWithFirebase()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.db.getConfigLocal("player")];
                    case 2:
                        player = _a.sent();
                        if (player) {
                            this.player = player;
                        }
                        return [4 /*yield*/, this.loadWinProofsFromLocal()];
                    case 3:
                        _a.sent();
                        this.firebaseSyncing = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Store.prototype.queryCacheInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cacheMusic, somethingMissingMusic, DOWNLOAD_AUDIBLE_MEDIA_KEYS_1, DOWNLOAD_AUDIBLE_MEDIA_KEYS_1_1, key, _a, _b, f, e_1_1, e_2_1, cacheImages, somethingMissingImages, _c, _d, f, e_3_1;
            var e_2, _e, e_1, _f, e_3, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0: return [4 /*yield*/, caches.open(CACHE_MUSIC_NAME_MP3)];
                    case 1:
                        cacheMusic = _h.sent();
                        somethingMissingMusic = false;
                        _h.label = 2;
                    case 2:
                        _h.trys.push([2, 14, 15, 16]);
                        DOWNLOAD_AUDIBLE_MEDIA_KEYS_1 = __values(DOWNLOAD_AUDIBLE_MEDIA_KEYS), DOWNLOAD_AUDIBLE_MEDIA_KEYS_1_1 = DOWNLOAD_AUDIBLE_MEDIA_KEYS_1.next();
                        _h.label = 3;
                    case 3:
                        if (!!DOWNLOAD_AUDIBLE_MEDIA_KEYS_1_1.done) return [3 /*break*/, 13];
                        key = DOWNLOAD_AUDIBLE_MEDIA_KEYS_1_1.value;
                        _h.label = 4;
                    case 4:
                        _h.trys.push([4, 9, 10, 11]);
                        _a = (e_1 = void 0, __values(this.index.dir[key].files)), _b = _a.next();
                        _h.label = 5;
                    case 5:
                        if (!!_b.done) return [3 /*break*/, 8];
                        f = _b.value;
                        return [4 /*yield*/, cacheMusic.match(DATA_DIR + f.filePath + f.fileName)];
                    case 6:
                        if (!(_h.sent())) {
                            somethingMissingMusic = true;
                            return [3 /*break*/, 8];
                        }
                        _h.label = 7;
                    case 7:
                        _b = _a.next();
                        return [3 /*break*/, 5];
                    case 8: return [3 /*break*/, 11];
                    case 9:
                        e_1_1 = _h.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 11];
                    case 10:
                        try {
                            if (_b && !_b.done && (_f = _a.return)) _f.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 11:
                        if (somethingMissingMusic) {
                            return [3 /*break*/, 13];
                        }
                        _h.label = 12;
                    case 12:
                        DOWNLOAD_AUDIBLE_MEDIA_KEYS_1_1 = DOWNLOAD_AUDIBLE_MEDIA_KEYS_1.next();
                        return [3 /*break*/, 3];
                    case 13: return [3 /*break*/, 16];
                    case 14:
                        e_2_1 = _h.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 16];
                    case 15:
                        try {
                            if (DOWNLOAD_AUDIBLE_MEDIA_KEYS_1_1 && !DOWNLOAD_AUDIBLE_MEDIA_KEYS_1_1.done && (_e = DOWNLOAD_AUDIBLE_MEDIA_KEYS_1.return)) _e.call(DOWNLOAD_AUDIBLE_MEDIA_KEYS_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 16:
                        if (!this.musicCacheInstallInfo) {
                            this.musicCache = somethingMissingMusic ? "no" : "yes";
                        }
                        return [4 /*yield*/, caches.open(CACHE_IMAGES_NAME)];
                    case 17:
                        cacheImages = _h.sent();
                        somethingMissingImages = false;
                        _h.label = 18;
                    case 18:
                        _h.trys.push([18, 23, 24, 25]);
                        _c = __values(this.index.dir.images.files), _d = _c.next();
                        _h.label = 19;
                    case 19:
                        if (!!_d.done) return [3 /*break*/, 22];
                        f = _d.value;
                        return [4 /*yield*/, cacheImages.match(DATA_DIR + f.filePath + f.fileName)];
                    case 20:
                        if (!(_h.sent())) {
                            somethingMissingImages = true;
                            return [3 /*break*/, 22];
                        }
                        _h.label = 21;
                    case 21:
                        _d = _c.next();
                        return [3 /*break*/, 19];
                    case 22: return [3 /*break*/, 25];
                    case 23:
                        e_3_1 = _h.sent();
                        e_3 = { error: e_3_1 };
                        return [3 /*break*/, 25];
                    case 24:
                        try {
                            if (_d && !_d.done && (_g = _c.return)) _g.call(_c);
                        }
                        finally { if (e_3) throw e_3.error; }
                        return [7 /*endfinally*/];
                    case 25:
                        if (!this.imagesCacheInstallInfo) {
                            this.imagesCache = somethingMissingImages ? "no" : "yes";
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Store.prototype.installMusicCache = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cacheMusic, DOWNLOAD_AUDIBLE_MEDIA_KEYS_2, DOWNLOAD_AUDIBLE_MEDIA_KEYS_2_1, key, _a, _b, f, url, data, e_4_1, e_5_1;
            var e_5, _c, e_4, _d;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (this.musicCacheInstallInfo) {
                            return [2 /*return*/];
                        }
                        this.musicCacheInstallInfo = {
                            currentFile: "",
                            sizeTotal: DOWNLOAD_AUDIBLE_MEDIA_KEYS.map(function (key) { return _this.index.dir[key].totalSize; }).reduce(function (acc, cur) { return acc + cur; }, 0),
                            downloaded: 0,
                        };
                        return [4 /*yield*/, caches.open(CACHE_MUSIC_NAME_MP3)];
                    case 1:
                        cacheMusic = _e.sent();
                        _e.label = 2;
                    case 2:
                        _e.trys.push([2, 14, 15, 16]);
                        DOWNLOAD_AUDIBLE_MEDIA_KEYS_2 = __values(DOWNLOAD_AUDIBLE_MEDIA_KEYS), DOWNLOAD_AUDIBLE_MEDIA_KEYS_2_1 = DOWNLOAD_AUDIBLE_MEDIA_KEYS_2.next();
                        _e.label = 3;
                    case 3:
                        if (!!DOWNLOAD_AUDIBLE_MEDIA_KEYS_2_1.done) return [3 /*break*/, 13];
                        key = DOWNLOAD_AUDIBLE_MEDIA_KEYS_2_1.value;
                        _e.label = 4;
                    case 4:
                        _e.trys.push([4, 10, 11, 12]);
                        _a = (e_4 = void 0, __values(this.index.dir[key].files)), _b = _a.next();
                        _e.label = 5;
                    case 5:
                        if (!!_b.done) return [3 /*break*/, 9];
                        f = _b.value;
                        this.musicCacheInstallInfo.currentFile = f.fileName;
                        url = DATA_DIR + f.filePath + f.fileName;
                        return [4 /*yield*/, fetch(url)];
                    case 6:
                        data = _e.sent();
                        return [4 /*yield*/, cacheMusic.put(url, data)];
                    case 7:
                        _e.sent();
                        this.musicCacheInstallInfo.downloaded += f.size;
                        _e.label = 8;
                    case 8:
                        _b = _a.next();
                        return [3 /*break*/, 5];
                    case 9: return [3 /*break*/, 12];
                    case 10:
                        e_4_1 = _e.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 12];
                    case 11:
                        try {
                            if (_b && !_b.done && (_d = _a.return)) _d.call(_a);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 12:
                        DOWNLOAD_AUDIBLE_MEDIA_KEYS_2_1 = DOWNLOAD_AUDIBLE_MEDIA_KEYS_2.next();
                        return [3 /*break*/, 3];
                    case 13: return [3 /*break*/, 16];
                    case 14:
                        e_5_1 = _e.sent();
                        e_5 = { error: e_5_1 };
                        return [3 /*break*/, 16];
                    case 15:
                        try {
                            if (DOWNLOAD_AUDIBLE_MEDIA_KEYS_2_1 && !DOWNLOAD_AUDIBLE_MEDIA_KEYS_2_1.done && (_c = DOWNLOAD_AUDIBLE_MEDIA_KEYS_2.return)) _c.call(DOWNLOAD_AUDIBLE_MEDIA_KEYS_2);
                        }
                        finally { if (e_5) throw e_5.error; }
                        return [7 /*endfinally*/];
                    case 16:
                        this.musicCache = "yes";
                        this.musicCacheInstallInfo = undefined;
                        return [2 /*return*/];
                }
            });
        });
    };
    Store.prototype.installImagesCache = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cacheImages, USE_PARALLEL_LOADING, imagesCacheInstallInfo_1, DOWNLOADING_THREADS, filesBuckets, _a, _b, f, url, data, e_6_1;
            var e_6, _c;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (this.imagesCacheInstallInfo) {
                            return [2 /*return*/];
                        }
                        this.imagesCacheInstallInfo = {
                            currentFile: "",
                            sizeTotal: this.index.dir.images.totalSize,
                            downloaded: 0,
                        };
                        return [4 /*yield*/, caches.open(CACHE_IMAGES_NAME)];
                    case 1:
                        cacheImages = _d.sent();
                        USE_PARALLEL_LOADING = true;
                        if (!USE_PARALLEL_LOADING) return [3 /*break*/, 3];
                        imagesCacheInstallInfo_1 = this.imagesCacheInstallInfo;
                        DOWNLOADING_THREADS = 20;
                        filesBuckets = splitByBuckets(this.index.dir.images.files, DOWNLOADING_THREADS);
                        return [4 /*yield*/, Promise.all(filesBuckets.map(function (filesBucket) { return __awaiter(_this, void 0, void 0, function () {
                                var filesBucket_1, filesBucket_1_1, file, url, data, e_7_1;
                                var e_7, _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _b.trys.push([0, 6, 7, 8]);
                                            filesBucket_1 = __values(filesBucket), filesBucket_1_1 = filesBucket_1.next();
                                            _b.label = 1;
                                        case 1:
                                            if (!!filesBucket_1_1.done) return [3 /*break*/, 5];
                                            file = filesBucket_1_1.value;
                                            url = DATA_DIR + file.filePath + file.fileName;
                                            return [4 /*yield*/, fetch(url)];
                                        case 2:
                                            data = _b.sent();
                                            return [4 /*yield*/, cacheImages.put(url, data)];
                                        case 3:
                                            _b.sent();
                                            imagesCacheInstallInfo_1.downloaded += file.size;
                                            _b.label = 4;
                                        case 4:
                                            filesBucket_1_1 = filesBucket_1.next();
                                            return [3 /*break*/, 1];
                                        case 5: return [3 /*break*/, 8];
                                        case 6:
                                            e_7_1 = _b.sent();
                                            e_7 = { error: e_7_1 };
                                            return [3 /*break*/, 8];
                                        case 7:
                                            try {
                                                if (filesBucket_1_1 && !filesBucket_1_1.done && (_a = filesBucket_1.return)) _a.call(filesBucket_1);
                                            }
                                            finally { if (e_7) throw e_7.error; }
                                            return [7 /*endfinally*/];
                                        case 8: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 11];
                    case 3:
                        _d.trys.push([3, 9, 10, 11]);
                        _a = __values(this.index.dir.images.files), _b = _a.next();
                        _d.label = 4;
                    case 4:
                        if (!!_b.done) return [3 /*break*/, 8];
                        f = _b.value;
                        this.imagesCacheInstallInfo.currentFile = f.fileName;
                        url = DATA_DIR + f.filePath + f.fileName;
                        return [4 /*yield*/, fetch(url)];
                    case 5:
                        data = _d.sent();
                        return [4 /*yield*/, cacheImages.put(url, data)];
                    case 6:
                        _d.sent();
                        this.imagesCacheInstallInfo.downloaded += f.size;
                        _d.label = 7;
                    case 7:
                        _b = _a.next();
                        return [3 /*break*/, 4];
                    case 8: return [3 /*break*/, 11];
                    case 9:
                        e_6_1 = _d.sent();
                        e_6 = { error: e_6_1 };
                        return [3 /*break*/, 11];
                    case 10:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_6) throw e_6.error; }
                        return [7 /*endfinally*/];
                    case 11:
                        this.imagesCache = "yes";
                        this.imagesCacheInstallInfo = undefined;
                        return [2 /*return*/];
                }
            });
        });
    };
    Store.prototype.removeMusicCache = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.musicCacheInstallInfo) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, caches.delete(CACHE_MUSIC_NAME_MP3)];
                    case 1:
                        _a.sent();
                        this.musicCache = "no";
                        return [2 /*return*/];
                }
            });
        });
    };
    Store.prototype.removeImagesCache = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.imagesCacheInstallInfo) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, caches.delete(CACHE_IMAGES_NAME)];
                    case 1:
                        _a.sent();
                        this.imagesCache = "no";
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Store.prototype, "defaultMusicList", {
        get: function () {
            var trackFolderList = this.index.dir.track.files
                .filter(function (fileInfo) { return fileInfo.useForRandomMusic; })
                .map(function (fileInfo) { return fileInfo.filePath + fileInfo.fileName; });
            return trackFolderList;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d, _e, _f, _g, _h;
    __decorate([
        observable,
        __metadata("design:type", typeof (_a = typeof Player !== "undefined" && Player) === "function" ? _a : Object)
    ], Store.prototype, "player", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "pwaInstallReadyEvent", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], Store.prototype, "pwaAlreadyInstalled", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], Store.prototype, "_hash", void 0);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Store.prototype, "hash", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Store.prototype, "path", null);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "firebaseLoggedIn", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], Store.prototype, "firebaseSyncing", void 0);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Store.prototype, "l", null);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "wonProofs", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], Store.prototype, "serviceWorkerRegistered", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "serviceWorkerController", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], Store.prototype, "reloadingPage", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "storageIsPersisted", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "installingServiceWorkerState", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "waitingServiceWorkerState", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "waitingServiceWorker", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "activeServiceWorkerState", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], Store.prototype, "questsListTab", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], Store.prototype, "questsListSearch", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "imagesCache", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "imagesCacheInstallInfo", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "musicCache", void 0);
    __decorate([
        observable,
        __metadata("design:type", Object)
    ], Store.prototype, "musicCacheInstallInfo", void 0);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], Store.prototype, "defaultMusicList", null);
    return Store;
}());
export { Store };
/*
- page is server by sw.js: true/false
- another installing
- another waiting

*/
//# sourceMappingURL=data:application/json;base64,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